





































import { Component, Vue } from 'vue-property-decorator';
import { conceptWebservice } from '@/webservices/concept';
import type { GlobalPMSubPhase } from '@/models/pmsubphase';
import GlobalSubPhases from '@/components/knowledge/globals/GlobalSubPhases.vue';
import { Getter } from 'vuex-class';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'GlobalSubPhasesContainer',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        GlobalSubPhases,
    },
})
export default class GlobalSubPhasesContainer extends Vue {
    protected globalSubPhases: GlobalPMSubPhase[] = [];
    private isLoaded: boolean = false;
    private editMode: boolean = false;
    @Getter('account/userInfo') private userInfo: User;

    private mounted() {
        this.load();
    }

    private async load() {
        this.globalSubPhases = await conceptWebservice.loadPm();
        this.isLoaded = true;
    }

    private async toggleEdit() {
        this.isLoaded = false;
        if (this.editMode) {
            this.globalSubPhases = await conceptWebservice.loadPm(true, true);
            this.editMode = false;
        } else {
            this.globalSubPhases = await conceptWebservice.loadPm(false, true);
            this.editMode = true;
        }
        this.isLoaded = true;
    }

    private async update(global: GlobalPMSubPhase) {
        await conceptWebservice.updateGlobal(global);
        this.$buefy.toast.open({
            duration: 2000,
            message: this.$t('toastMessages.update.generic', {
                x: this.$tc('keywords.pmConcept', 1),
            }).toString(),
            type: 'is-success',
        });
    }
}
